import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons//Check';
import Box from '@mui/material/Box';
import { TableBaseStyle, LoginUserSettingStyle } from './LoginUserSettingStyle';

type LoginUserSettingFooterPage = { onOK: () => void; onCancel: () => void };

const LoginUserSettingFooter: React.FC<LoginUserSettingFooterPage> = (props) => {
  const { t } = useTranslation();
  const pageStyle = LoginUserSettingStyle();

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center">
      <Grid item xs={2}>
        <Button
          variant="contained"
          color="primary"
          className={pageStyle.buttonStyle}
          onClick={(e) => {
            props.onOK();
          }}
        >
          {t('LoginUserSettingFooter.OK', 'OK')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button variant="contained" color="primary" className={pageStyle.buttonStyle} onClick={(e) => props.onCancel()}>
          {t('LoginUserSettingFooter.キャンセル', 'キャンセル')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default LoginUserSettingFooter;
